import { useNavigate, useLocation } from 'react-router-dom';
import { ShoppingBag, RefreshCw, MessageCircle, ShoppingCart, Send } from 'lucide-react';

const ClientBottomBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { path: '/cliente/servicios', icon: ShoppingBag, label: 'Servicios', color: 'text-emerald-600' },
    { path: '/cliente/carrito', icon: ShoppingCart, label: 'Carrito', color: 'text-blue-600' },
    { path: '/cliente/divisas', icon: RefreshCw, label: 'Divisas', color: 'text-violet-600' },
    { path: '/cliente/transferencias', icon: Send, label: 'Envios', color: 'text-amber-600' },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 lg:hidden bg-white border-t border-slate-200 z-40 safe-area-inset-bottom" data-testid="client-bottom-bar">
      <div className="flex items-center justify-around py-2 px-2">
        {items.map((item) => {
          const active = location.pathname === item.path;
          return (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center gap-1 px-4 py-1.5 rounded-xl transition-all ${active ? 'bg-emerald-50' : 'hover:bg-slate-50'}`}
              data-testid={`bottom-${item.label.toLowerCase()}`}
            >
              <item.icon className={`w-5 h-5 ${active ? item.color : 'text-slate-400'}`} />
              <span className={`text-[10px] font-medium ${active ? item.color : 'text-slate-400'}`}>{item.label}</span>
            </button>
          );
        })}
        <button
          onClick={() => window.document.querySelector('[data-testid="whatsapp-toggle"]')?.click()}
          className="flex flex-col items-center gap-1 px-4 py-1.5 rounded-xl hover:bg-slate-50"
          data-testid="bottom-soporte"
        >
          <MessageCircle className="w-5 h-5 text-green-500" />
          <span className="text-[10px] font-medium text-green-500">Soporte</span>
        </button>
      </div>
    </div>
  );
};

export default ClientBottomBar;
